import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import { useStore } from "utils/useStore";
import { LLMClassifierBuilderStore } from "../Stores/LLMClassifierBuilderStore";
import { DataLabelingModuleQuestionSelector } from "./DataLabelingModuleQuestionSelector";
import { DataLabelingModuleSelector } from "./DataLabelingModuleSelector";
import React from "react";
import { LLMClassifierBuilderStepperStore } from "../Stores/LLMClassifierBuilderStepperStore";

export const DataLabelingModuleAndQuestionSelectors = observer(function () {
    const store = useStore(LLMClassifierBuilderStore);
    const stepper = useStore(LLMClassifierBuilderStepperStore);

    return (
        <Grid container columns={2} columnGap={2} flexWrap="nowrap">
            <Grid item xs={1}>
                <DataLabelingModuleSelector
                    id="model-module"
                    fullWidth
                    required={!store.isEditing}
                    inputLabel="Data Labeling Module"
                    isDisabled={!store.isEditing && store.isSaved}
                    defaultValue={store.dataLabelingModule}
                    onChange={(module) => store.setLinkedModule(module)}
                    error={
                        !store.dataLabelingModule &&
                        stepper.hasError.moduleMissing
                    }
                />
            </Grid>
            <Grid item xs={1}>
                <DataLabelingModuleQuestionSelector
                    id="model-question"
                    fullWidth
                    required={!store.isEditing}
                    inputLabel="Module Question"
                    isDisabled={!store.isEditing && store.isSaved}
                    moduleId={store.dataLabelingModule?.id}
                    defaultValue={store.dataLabelingQuestion}
                    onChange={(question) => store.setLinkedQuestion(question)}
                    error={
                        !store.dataLabelingQuestion &&
                        stepper.hasError.questionMissing
                    }
                />
            </Grid>
        </Grid>
    );
});
